import marketingInstance from '../instance'

const updateFlyerCoupon = (id, data) => {
  return marketingInstance.put(`/flyerCoupons/${id}`, data)
}

export default updateFlyerCoupon